<script setup lang="ts">
  import type { IPageData } from '@/storyblok/page-type/PageType.types'
  import type { IBreadcrumb } from '@/components/breadcrumbs/types'

  const props = defineProps<{
    blok: IPageData
    breadcrumbs: IBreadcrumb[]
  }>()

  const { isMobile, isTablet, isDesktop } = useBTBreakpoints()

  const hasSidebarContent = computed(() => props.blok.sidebarMenu)
</script>

<template>
  <StoryblokComponent
    :is="blok.sidebarMenu"
    v-if="hasSidebarContent && (isMobile || isTablet)"
    :blok="blok.sidebarMenu.content"
    :show-mobile="true"
  />

  <section class="flex flex-col gap-6 md:gap-10">
    <Hero
      v-if="blok?.hero?.filename"
      :blok="blok"
    />

    <Breadcrumbs
      v-if="breadcrumbs.length && isDesktop"
      :breadcrumbs="breadcrumbs"
      :has-hero="!!blok?.hero?.filename"
    />

    <main
      id="main-content"
      class="container mb-20 flex flex-col justify-start gap-16 md:flex-row xl:gap-36"
    >
      <aside
        v-if="hasSidebarContent && isDesktop && !blok.noSidebarOnDesktop"
        class="shrink-0 md:w-80 xl:w-84"
      >
        <StoryblokComponent
          :is="blok.sidebarMenu"
          v-if="blok.sidebarMenu"
          class="rounded-sm shadow-lg"
          :blok="blok.sidebarMenu.content"
          :show-desktop="true"
        />
      </aside>
      <section class="order-0 flex w-full grow flex-col gap-6 md:order-1">
        <template
          v-for="body in blok.body"
          :key="body._uid"
        >
          <StoryblokComponent
            v-editable="body"
            :blok="body"
            :class="{ 'mt-0': blok?.hero?.filename }"
          />
        </template>
      </section>
    </main>
  </section>
</template>
